import { Box, styled } from '@mui/material';
import theme from 'App.theme';

const DatePickerStyles = styled(Box)`
  & .rdp {
    --rdp-cell-size: 40px;
    --rdp-accent-color: ${theme.colors.active};
    --rdp-background-color: ${theme.colors.activeLight};
    --rdp-accent-color-dark: ${theme.colors.active};
    --rdp-background-color-dark: ${theme.colors.activeLight};
    --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */
    --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */
    margin: 1em;
  }
` as typeof Box;

export default DatePickerStyles;
